import * as React from "react";
import * as Comp from "../../../../components";
import { ComponentWithValidatedForm } from "../../../../components/validation";
import { Paths } from "../../../../constants";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";

interface OwnProps {
    api: Api;
    abstract: M.Abstract.Abstract;
    eventId: number;
    onSubmit: (model: Forms.AdminAbstract.AbstractSettingsData, body: any) => void;
}

interface OwnState {
}

export class SettingsForm extends ComponentWithValidatedForm<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.AdminAbstract.AbstractSettings();
        this.state = {
            ...this.getInitialState(formModel),
        };
    }

    public componentDidMount() {
        this.setFormData(this.props.abstract);
    }

    public setFormData(abstract: M.Abstract.Abstract) {
        const formModel = this.getFormModel() as Forms.AdminAbstract.AbstractSettings;
        formModel.data.cmeEnabled = abstract.cmeEnabled;
        formModel.data.cmeHours = abstract.cmeHours;
        formModel.data.invitationResponseId = abstract.invitationResponseId == null
            ? M.Abstract.InvitationResponse.NoResponse.id
            : abstract.invitationResponseId;
        formModel.data.statusId = abstract.statusId;
    }

    public render() {
        const formModel = this.getFormModelData<Forms.AdminAbstract.AbstractSettingsData>();
        const cancelLink = Paths.AdminAbstractDetails(this.props.eventId, this.props.abstract.guid);

        const cmeHoursEditor = formModel.cmeEnabled
            ? <Comp.Editors.NumberField formComponent={this} name="cmeHours" />
            : null;

        const invRespItems: M.Editors.SelectItem[] = M.Abstract.InvitationResponse.Values
            .map((v) => ({
                id: v.id,
                render: v.name,
            }));

        const statusItems: M.Editors.SelectItem[] = M.Abstract.AbstractStatuses.Values
            .filter((v) => v.id !== M.Abstract.AbstractStatuses.Deleted.id)
            .map((v) => ({
                id: v.id,
                render: v.name,
            }));

        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onValidSubmit={async (model) => this.handleSubmit(model)}
            schema={this.state.formModel.rules}
            ref={(ref: any) => this.form = ref}
        >
            <Comp.Editors.CheckboxField formComponent={this} name="cmeEnabled" />
            {cmeHoursEditor}
            <Comp.Editors.DropdownField formComponent={this} name="invitationResponseId" items={invRespItems} />
            <Comp.Editors.DropdownField formComponent={this} name="statusId" items={statusItems} />
            <Comp.Editors.SubmitField cancelLink={cancelLink} label="Save" showProcessing={this.state.formProcessing} />

        </Comp.Validation.ValidatedForm>;
    }

    private handleSubmit(model: Forms.AdminAbstract.AbstractSettingsData) {
        const body = {
            cmeEnabled: model.cmeEnabled,
            cmeHours: model.cmeHours,
            guid: this.props.abstract.guid,
            invitationResponseId: model.invitationResponseId,
            statusId: model.statusId,
        };

        this.props.onSubmit(model, body);
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/edit/components/SettingsForm.tsx